export interface IPaymentSummarySearchCriteria {
    organizationName: string;
    policyholderIds:Array<string>  
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;
    decisionTypeCode:string;
}


export class PaymentSummarySearchCriteria implements IPaymentSummarySearchCriteria {
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;
    organizationName: string;
    policyholderIds:Array<string>  
    decisionTypeCode:string;
}